import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageNumber: 1,
  MyProducts: [],
  lastAction: null,
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    changePageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    loadMyStore: (state, action) => {
      state.MyProducts = action.payload;
    },
    addToStore: (state, action) => {
      state.lastAction = { type: 'add', product: action.payload };
      state.MyProducts.unshift(action.payload);
    },
    removeFromStore: (state, action) => {
      const productToRemove = state.MyProducts.find(item => item._id === action.payload);
      if (productToRemove) {
        state.lastAction = { type: 'remove', product: productToRemove };
        state.MyProducts = state.MyProducts.filter(item => item._id !== action.payload);
      }
    },
    editInStore: (state, action) => {
      const { _id, ...updatedFields } = action.payload;
      const index = state.MyProducts.findIndex(product => product._id === _id);
      if (index !== -1) {
        console.log("--------------------------------================");
        console.log("I am in here");
        console.log("--------------------------------================");
        state.lastAction = { 
          type: 'edit', 
          product: { ...state.MyProducts[index] }  // Store the original product
        };
        state.MyProducts[index] = { ...state.MyProducts[index], ...updatedFields };
      }
    },
    updateStoreAfterAdd: (state, action) => {
      const { tempId, serverProduct } = action.payload;
      const index = state.MyProducts.findIndex(product => product._id === tempId);
      if (index !== -1 && serverProduct) {
        // Replace the temporary product with the real product from the server
        state.MyProducts[index] = serverProduct;
      }
    },
    updateStoreAfterEdit: (state, action) => {
      const { _id, serverProduct } = action.payload;
      const index = state.MyProducts.findIndex(product => product._id === _id);
      if (index !== -1) {
        // Replace the entire product with the server response
        state.MyProducts[index] = serverProduct;
      }
    },
    rollbackStore: (state) => {
      if (state.lastAction.type === 'add') {
        state.MyProducts = state.MyProducts.filter(
          item => item._id !== state.lastAction.product._id
        );
      } else if (state.lastAction.type === 'remove') {
        state.MyProducts.unshift(state.lastAction.product);
      } else if (state.lastAction.type === 'edit') {
        const index = state.MyProducts.findIndex(product => product._id === state.lastAction.product._id);
        if (index !== -1) {
          state.MyProducts[index] = state.lastAction.product;
        }
      }
      state.lastAction = null;
    },
  },
});

export const {
  changePageNumber,
  loadMyStore,
  addToStore,
  removeFromStore,
  editInStore,
  updateStoreAfterAdd,
  updateStoreAfterEdit,
  rollbackStore
} = productSlice.actions;

export const selectMyProducts = (state) => state.products.MyProducts;
export default productSlice.reducer;